import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Coins,
  Settings,
  X,
  ShieldCheck,
  PanelLeftClose,
  PanelLeftOpen,
  Building2,
  BarChart3,
  CreditCard,
  LogOut,
  Globe
} from "lucide-react";

import API from "../../api/api";
import { setUser } from "../../store/userSlice";
import "../../style/admin-sidebar.css";

const navLinks = [
  { to: "/admin", label: "Dashboard", icon: <LayoutDashboard size={18}/> },
  { to: "/admin/users", label: "Users", icon: <Users size={18}/> },
  { to: "/admin/payments", label: "Payments", icon: <CreditCard size={18}/> },
  { to: "/admin/credits", label: "Credits", icon: <Coins size={18}/> },
  { to: "/admin/usage", label: "Usage", icon: <BarChart3 size={18}/> },
  { to: "/admin/plans", label: "Plans", icon: <Coins size={18}/> },
  { to: "/admin/departments", label: "Departments", icon: <Building2 size={18}/> },
  { to: "/admin/states", label: "States", icon: <Globe size={18}/> },
  { to: "/admin/settings", label: "Settings", icon: <Settings size={18}/> }
];

export default function AdminSidebar({ open, setOpen }) {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await API.post("/admin/logout");
    } catch (err) {}

    localStorage.removeItem("grgpt_token");
    dispatch(setUser(null));
    navigate("/admin/login");
    setOpen(false);
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`admin-sidebar-overlay ${open ? "visible" : ""}`}
        onClick={() => setOpen(false)}
      />

      <aside
        className={`admin-sidebar ${open ? "open" : ""} ${
          collapsed ? "collapsed" : ""
        }`}
      >
        {/* HEADER */}
        <div className="admin-sidebar-header">
          <div className="admin-sidebar-brand">
            <ShieldCheck size={20} className="admin-sidebar-brand-icon" />
            {!collapsed && (
              <h4 className="admin-sidebar-title">Admin Panel</h4>
            )}
          </div>

          <button
            className="admin-sidebar-collapse-btn"
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? (
              <PanelLeftOpen size={18} />
            ) : (
              <PanelLeftClose size={18} />
            )}
          </button>

          <button
            className="admin-sidebar-close"
            onClick={() => setOpen(false)}
          >
            <X size={18} />
          </button>
        </div>

        {/* NAV */}
        <nav className="admin-sidebar-nav">
          {navLinks.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/admin"}
              className={({ isActive }) =>
                `admin-link ${isActive ? "active" : ""}`
              }
              onClick={() => setOpen(false)}
            >
              <span className="admin-link-icon">{icon}</span>

              {!collapsed && (
                <span className="admin-link-label">{label}</span>
              )}
            </NavLink>
          ))}
        </nav>

        {/* FOOTER */}
        <div className="admin-sidebar-footer">
          <button className="admin-sidebar-logout" onClick={handleLogout}>
            <span className="admin-sidebar-logout-icon">
              <LogOut size={18} />
            </span>
            {!collapsed && <span className="admin-sidebar-logout-label">Logout</span>}
          </button>

          {!collapsed && (
            <>
              <div className="admin-footer-line" />
              <span className="admin-sidebar-version">v1.0.0</span>
            </>
          )}
        </div>
      </aside>
    </>
  );
} 
